const Winners = () => {

    return (
        <div className="">
            <div className="container mx-auto items-center p-4 grid grid-cols-1 gap-4">
                <embed src="/src/assets/pdfs/2026Winners.pdf" type="application/pdf" width="100%" height="800px" />
            </div>
        </div>
    );
};

export default Winners;
